import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useState } from 'react';

import DocumentRepositoryTree from '../../../components/DocumentRepositoryTree';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';

const useStyles = makeStyles({
  zoomDialogPaperFullWidth: {
    maxWidth: '50%',
  },
  muiDialogContent: {
    '& [class*="MuiDialogActions"]': {
      marginBottom: 20,
      marginTop: 5,
    },
  },
});

const RepositoryZoomDialog = ({ open, onClose, onSelect, dynamicParamCollection = {} }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [selectedItem, setSelectedItem] = useState();
  const [selectedPath, setSelectedPath] = useState();

  const { repositoryName } = dynamicParamCollection;

  const handleRepositoryItemClick = (item, path) => {
    setSelectedItem(item);
    setSelectedPath(path);
  };

  const handleSelectRepository = () => {
    onClose();
    onSelect({ selectedItem, selectedPath });
  };

  const buttonProps = [
    { label: translateString('Cancel'), onClick: onClose },
    { label: translateString('Select'), onClick: handleSelectRepository },
  ];

  return (
    <Modal
      open={open}
      title={repositoryName}
      classes={{
        paperFullWidth: classes.zoomDialogPaperFullWidth,
        paper: classes.muiDialogContent,
      }}
      onClose={onClose}
      fullWidth
      disableEnforceFocus
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={buttonProps}
    >
      <span ui-ta={getUITA('SSRepositoryZoomDialog')}>
        <div className={classes.tableCtr}>
          <DocumentRepositoryTree
            repositoryName={repositoryName}
            onSelectItem={handleRepositoryItemClick}
          />
        </div>
      </span>
    </Modal>
  );
};

export default RepositoryZoomDialog;
